export default __webpack_public_path__ + "static/media/arrow-left.1f5cf7e4.svg";